/****
 * a listing of partner programs that the reseller does NOT participate
 * in.  Component is self contained and can be put anywhere
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import TabPageTitle from '../ui/TabPageTitle';
import AppLogo from '../ui/AppLogo';
import withStyles from '@mui/styles/withStyles';
import { Grid, Link, Paper, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, TablePagination, TableSortLabel, Typography } from '@mui/material';

import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

const abEnvironment = new AbEnvironment();
const PartnerProgramsDiscoveryQuery = graphql`
query PartnerProgramsDiscoveryQuery($accountId: UUID!, $orderBy: Int, $direction: Int, $first: Int, $offset: Int) {
  getpartnerprogramsnotassociated(accountid: $accountId, orderby: $orderBy, orderdirection: $direction, first: $first, offset: $offset) { 
    totalCount 
     nodes 
     { 
       vppId
       vendorId
       vendorName
       vendorLogo
       programName
       description
     }
   } 
 }
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  tblHeadRow: {
    height: 32,
  }
});

class PartnerProgramsDiscovery extends Component {

  constructor(props) {
    super(props);

    this.state = {
      orderBy:           1,
      orderDir:          1,  
      page:              0,
      rowsPerPage:       10
    };  
  }

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  toggleOrder = (ob) => {

    let newDir = 0;
    if (ob === this.state.orderBy) {
      if (this.state.orderDir === 0) {
        newDir = 1;
      }
    } else {
      newDir = 1;
    }

    this.setOrderBy(ob, newDir);
  } 

  setOrderBy = (ob, dir) => {
    let thedir = dir;
    if (dir === 'asc') {
      thedir = 1;
    } else if (dir === 'desc') {
      thedir = 0;
    }
    if (thedir !== 0 && thedir !== 1) {
      thedir = 1;
    }
    this.setState({orderBy: ob, orderDir: thedir, page : 0});
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let theDir = 'asc';
    if (this.state.orderDir === 0) {
      theDir = 'desc';
    }

    if (isAuthenticatedReseller())
    {
      let accountId = abEnvironment.getUserAttribute('a_id');

      return (
        <div className={classes.root}>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={PartnerProgramsDiscoveryQuery}
            variables={{accountId: accountId,
                        orderBy: this.state.orderBy,
                        direction: this.state.orderDir,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                let rprogs = props.getpartnerprogramsnotassociated.nodes;
                let counter = 0;

                if ((rprogs == null || rprogs.length === 0)) {
                  return (null);
                } else {
                  return (
                    <Grid container spacing={2} direction="row" justifyContent="flex-start">
                      <Grid item xs={12}>
                        <TabPageTitle title="Earn commissions from apps" subtitle="Learn about and register for partner programs."/>
                      </Grid>
                      <Grid item xs={12}>
                        
                        {(rprogs != null && rprogs.length > 0) &&
                        <Paper>
                          <TableContainer>
                            <Table>
                              <TableHead className={classes.tblHead}>
                                <TableRow  className={classes.tblHeadRow}>
                                  <TableCell>
                                    <TableSortLabel
                                        active={this.state.orderBy === 1}
                                        direction={theDir}
                                        onClick={() => this.toggleOrder(1) }>
                                        Vendor
                                    </TableSortLabel>
                                  </TableCell>
  
                                  <TableCell>
                                    <TableSortLabel
                                        active={this.state.orderBy === 2}
                                        direction={theDir}
                                        onClick={() => this.toggleOrder(2) }>
                                        Program
                                    </TableSortLabel>
  
                                  </TableCell>
                                  <TableCell>Description</TableCell>
                                  
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {rprogs.map(n => {
                                  let programName = n.programName;
                                  let description = n.description;
                                  let vendorName = n.vendorName;
                                  let vendorLogo = n.vendorLogo;
                                  let aUrl = 'vendorpartnerprogram?vppId=' + n.vppId;
  
                                  return (
                                    <TableRow key={counter++ }>
                                      <TableCell>
                                        <Grid container alignItems="center" spacing={1}>
                                          <Grid item>
                                            <AppLogo logoPath={vendorLogo} appName={vendorName} imageHeight='24px' theStyle={{marginRight: '8px'}}/>
                                          </Grid>
                                          <Grid item>
                                            {vendorName}
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                      <TableCell>
                                      <Link component="button" 
                                            variant="body2"
                                            
                                            onClick={this.goTo.bind(this, aUrl)}>
                                        {programName}
                                      </Link>
                                      </TableCell>
                                      <TableCell>{description}</TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <div style={{marginTop: '10px'}}>
                            <TablePagination
                              rowsPerPageOptions={[5, 10, 25]}
                              component="div"
                              count={props.getpartnerprogramsnotassociated.totalCount}
                              rowsPerPage={this.state.rowsPerPage}
                              page={this.state.page}
                              backIconButtonProps={{
                                'aria-label': 'Previous Page',
                              }}
                              nextIconButtonProps={{
                                'aria-label': 'Next Page',
                              }}
                              onPageChange={this.handleChangePage}
                              onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />                        
                          </div>
                        </Paper>}
                      </Grid>
                    </Grid>
                  )
  
                }
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </div>
      );
    }
    else
    {
      return (
        <Redirect to='/home' />
      );
    }
  }

}

export default withStyles(styleSheet)(PartnerProgramsDiscovery);
